import { IconNode, Icon } from './iconQueries';
import merge from 'lodash/merge';
import { getMultiChoice } from './index';

export interface SortedIcons {
    byWellnessType: {
        [key: string]: {
            // the wellness type
            [key: string]: Icon[]; // the color
        };
    };
    byBlogTopic: {
        [key: string]: {
            // the blog topic
            [key: string]: Icon[]; // the color
        };
    };
}

export function iconSorter<SortedIcons>(icons: IconNode[]) {
    let sortedIcons: SortedIcons = {} as SortedIcons;

    for (let i = 0; i < icons.length; i++) {
        const icon = icons[i].node.elements;
        const blogTopic = getMultiChoice(icon.blog_topic);
        const wellnessType = getMultiChoice(icon.wellness_type);

        if (!blogTopic && !wellnessType) {
            continue;
        }

        const color = getMultiChoice(icon.color) || 'noColor';

        let mergeIcon = { byWellnessType: {}, byBlogTopic: {} };

        if (!!blogTopic) {
            mergeIcon.byBlogTopic = {
                [blogTopic]: {
                    [color]: [icon],
                    all: [icon],
                },
            };
        }

        if (!!wellnessType) {
            mergeIcon.byWellnessType = {
                [wellnessType]: {
                    [color]: [icon],
                    all: [icon],
                },
            };
        }

        merge(sortedIcons, mergeIcon);
    }

    return sortedIcons;
}
